/**
 * Portal Store - Configuração do portal público
 *
 * Carrega a config de portal_enabled do backend para decidir
 * se a landing page é o portal público ou o login.
 *
 * @since 2026-02-19
 */

import { create } from 'zustand';

interface PortalState {
  portalEnabled: boolean;
  isLoaded: boolean;
  isLoading: boolean;
  load: () => Promise<void>;
}

export const usePortalStore = create<PortalState>((set, get) => ({
  portalEnabled: false,
  isLoaded: false,
  isLoading: false,

  load: async () => {
    if (get().isLoaded || get().isLoading) return;

    set({ isLoading: true });

    try {
      const response = await fetch('/api/v1/content/home');
      if (response.ok) {
        const data = await response.json();
        set({
          portalEnabled: data.portal_enabled === true,
          isLoaded: true,
          isLoading: false,
        });
      } else {
        set({ portalEnabled: false, isLoaded: true, isLoading: false });
      }
    } catch {
      set({ portalEnabled: false, isLoaded: true, isLoading: false });
    }
  },
}));

export default usePortalStore;
